import React from "react";
import { Truck, Leaf, RotateCcw } from "lucide-react";

// Pale cream & blush tones sampled from the banner photo
const GLOW = [
  "radial-gradient(55% 40% at 12% 12%, #EDD3C5 0%, transparent 70%)",
  "radial-gradient(45% 35% at 88% 28%, #F2E1D1 0%, transparent 70%)",
  "radial-gradient(50% 35% at 25% 62%, #F0DCD0 0%, transparent 70%)",
  "radial-gradient(50% 40% at 82% 88%, #ECD2C4 0%, transparent 70%)",
].join(", ");

export function GlassArea({ children }) {
  return (
    <div className="relative isolate overflow-hidden" data-testid="home-glass-area">
      <div aria-hidden className="absolute inset-0 -z-10 bg-[#FBF7F3]">
        <div className="absolute -inset-[8%] blur-[70px]" style={{ background: GLOW }} />
        <div className="absolute inset-0 bg-white/25" />
      </div>
      <div className="max-w-[1600px] mx-auto px-3 sm:px-6 lg:px-12 py-8 sm:py-14 lg:py-20 space-y-4 sm:space-y-6 lg:space-y-8">
        {children}
      </div>
    </div>
  );
}

export function GlassPanel({ children, className = "", testId, tint = "bg-white/45" }) {
  return (
    <section
      data-testid={testId}
      className={`rounded-[24px] sm:rounded-[32px] ${tint} backdrop-blur-2xl backdrop-saturate-150 ${className}`}
    >
      {children}
    </section>
  );
}

const TRUST_POINTS = [
  { icon: Truck, text: "Free shipping over $75", id: "free-shipping" },
  { icon: Leaf, text: "Clean ingredients", id: "clean-ingredients" },
  { icon: RotateCcw, text: "Easy returns", id: "easy-returns" },
];

export function TrustPoints() {
  return (
    <GlassPanel testId="trust-points" className="px-5 py-5 sm:px-10 sm:py-7">
      <ul className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
        {TRUST_POINTS.map(({ icon: Icon, text, id }) => (
          <li key={id} className="flex items-center sm:justify-center gap-3" data-testid={`trust-${id}`}>
            <span className="w-10 h-10 rounded-full bg-white/70 flex items-center justify-center flex-shrink-0">
              <Icon className="w-[18px] h-[18px] text-[#333333]" strokeWidth={1.5} />
            </span>
            <span className="font-sans text-[15px] text-[#333333]">{text}</span>
          </li>
        ))}
      </ul>
    </GlassPanel>
  );
}
